import * as Diagram from "../../../../components/diagram";

export const ElderlyHealthVisitList = {
  label: "老人健康訪視清冊",
  key: "ElderlyHealthVisitList",
  path: "ElderlyHealth/ElderlyHealthVisitList",
  api: "TCS_V_ElderlyHealthVisitList",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthVisitList {...options} />
  ),
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "訪視日期", key: "2570" }],
  columns: [
    { key: "2570", field: "2570", header: "訪視日期" },
    { key: "2579", field: "2579", header: "訪視人員" },
    { key: "PID", field: "PID", header: "身分證字號" },
    { key: "Name", field: "Name", header: "姓名" },
    { key: "2569", field: "2569", header: "訪視方式" },
    { key: "2572", field: "2572", header: "訪視紀錄" },
    { key: "2622", field: "2622", header: "資源連結項目" },
  ],
};
